export enum RoomDifficulty {
  INFO = 'info',
  EASY = 'easy',
  MEDIUM = 'medium',
  HARD = 'hard',
  INSANE = 'insane',
}

export enum RoomStatus {
  UNRELEASED = 'unreleased',
  EVALUATING = 'evaluating',
  READY = 'ready',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  SUBMITTED = 'submitted',
}

export enum RoomSubmissionAction {
  EVALUATE = 'evaluate',
  ACCEPT = 'accept',
  ACCEPT_NO_NOTIFICATION = 'accept-no-notification',
  REJECT = 'reject',
  READY = 'ready',
  COMMENT = 'comment',
  SCHEDULE = 'schedule',
  CLEAR_DATE = 'clear-date',
}

export enum RoomType {
  CHALLENGE = 'challenge',
  WALKTHROUGH = 'walkthrough',
}

export enum RoomUserEventType {
  INSTANCES_INTERRUPTION = 'instance-interruption',
  ENVIRONMENT_GENERATION = 'environment-generation',
}

export enum RoomEventType {
  NETWORK_RESETTING = 'network-resetting',
}

export enum VideoSource {
  THM = 'THM',
  YT = 'YT',
}

export enum VideoType {
  THM = 'THM',
}

export enum RoomCreatorType {
  TRYHACKME = 'tryhackme',
  COMMUNITY = 'community',
}
